import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { carService, shareService } from '../../../services'
import CrudEmpty from '../../crud/CrudEmpty'
import styled from 'styled-components'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import DateRangeIcon from '@mui/icons-material/DateRange'
import TodayIcon from '@mui/icons-material/Today'
import BoltIcon from '@mui/icons-material/Bolt'
import CarRentalIcon from '@mui/icons-material/CarRental'
import CustomPaginationActionsTable from '../../table/Table'

const moment = require('moment')

export default function Dashboard() {
    const navigate = useNavigate()
    const { t, i18n } = useTranslation()
    const [anchorEl, setAnchorEl] = React.useState(null)

    const [data, setData] = React.useState<any>(null)
    const [share, setShare] = React.useState<any>(null)

    useEffect(() => {
        searchData()
    }, [])

    const searchData = () => {
        carService.dashboard((data, error) => {
            if (data && data.data) {
                setData(data.data)
            }
        })

        shareService.pageFilter(0, 10, {}, (data, error) => {
            if (data && data.data) {
                setShare(data.data)
            }
        })
    }

    return (
        <CrudEmpty i18n={'dashboard'} goback={true}>
            <div>
                <Grid container>
                    <Grid item sm={4} xs={12}>
                        <PanelInfo>
                            <h2>Rental</h2>
                            <p>
                                <BoltIcon />
                                <b>Activos: </b>{' '}
                                <span> {data?.rents?.actives} </span>
                            </p>
                            <p>
                                <CarRentalIcon />
                                <b>Reservados: </b>{' '}
                                <span> {data?.rents?.reserves} </span>
                            </p>
                            <p>
                                <DateRangeIcon />
                                <b>Últimos 7 dias: </b>{' '}
                                <span> {data?.rents?.day7} </span>
                            </p>
                            <p>
                                <CalendarMonthIcon />
                                <b>Últimos 30 dias: </b>{' '}
                                <span> {data?.rents?.day30} </span>
                            </p>
                        </PanelInfo>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <PanelInfo>
                            <h2>Share</h2>
                            <p>
                                <BoltIcon />
                                <b>Activos: </b>{' '}
                                <span> {data?.shares?.actives} </span>
                            </p>
                            <p>
                                <DateRangeIcon />
                                <b>Últimos 7 dias: </b>{' '}
                                <span> {data?.shares?.day7} </span>
                            </p>
                            <p>
                                <CalendarMonthIcon />
                                <b>Últimos 30 dias: </b>{' '}
                                <span> {data?.shares?.day30} </span>
                            </p>
                        </PanelInfo>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <PanelInfo>
                            <h2>Usuarios</h2>
                            <p>
                                <TodayIcon />
                                <b>Nuevos hoy: </b>{' '}
                                <span> {data?.users?.actives} </span>
                            </p>
                            <p>
                                <DateRangeIcon />
                                <b>Nuevos últimos 7 dias: </b>{' '}
                                <span> {data?.users?.day7} </span>
                            </p>
                            <p>
                                <CalendarMonthIcon />
                                <b>Nuevos últimos 30 dias: </b>{' '}
                                <span> {data?.users?.day30} </span>
                            </p>
                        </PanelInfo>
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item sm={12} xs={12}>
                        <CustomPaginationActionsTable
                            t={t}
                            i18n={'share'}
                            labels={{
                                'user.email|user.name|user.lastname':
                                    'Conductor',
                                'car.brand|car.model|car.number': 'Vehículo',
                                seguro: '',
                            }}
                            rows={share}
                            fields={[
                                'user.email|user.name|user.lastname',
                                'car.brand|car.model|car.number',
                                'seguro',
                                'start',
                                'end',
                                'rentalState',
                                'total',
                                'km_real',
                            ]}
                            fieldId={'id'}
                            rowsPerPage={10}
                            rowsTotal={10}
                            hiddenpagination={true}
                            page={0}
                            deleteaction={false}
                            getDeleteButton={null}
                            getEditButton={null}
                            editable={false}
                            defaultValues={{}}
                            paintCell={{}}
                            paintvalue={{}}
                            moreActions={[]}
                            selectable={false}
                            handlerSelected={null}
                            conditionDelete={null}
                        />
                    </Grid>
                </Grid>
            </div>
        </CrudEmpty>
    )
}

const ImgaeIcon = styled.img`
    width: 50px;
    margin-left: 25px;
`

const PanelInfo = styled.div`
    margin: 2em;
    min-height: 220px;
    background: #83c63b77;
    padding: 1em;
    border-radius: 6px;
    font-size: 0.8em;
    line-height: 1em;

    & p {
        display: flex;
        flex-direction: row;
        align-items: center;

        & * {
            margin-right: 10px;
        }
    }

    @media (max-width: 767px) {
        margin: 0.2em;
    }
`

const PanelLegend = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    > div {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: start;
    }
`
